{
    "name": "Mushroom",
    "binomial_name": "",
    "common_names": [],
    "description": "Mushrooms are the fleshy, spore-bearing, fruiting body of a fungus. Mushrooms often have a stem, a cap, and gills on the underside of the cap - but not always. Commonly cultivated mushrooms include Oyster (the easiest and best for beginners), Shittake, King Stropharia or Wine Cap, Maitake, Lion's Mane, and Reishi. Mushrooms are generally grown by obtaining spores and inoculating a substrate (compost, cardboard, etc. Different types prefer different substrates) with the spores. Mushrooms can be grown indoors or outdoors, but it is often easier to cultivate them indoors because the light and moisture can be more thoroughly controlled. More growing information is available in individual species entries.",
    "sun_requirements": "Full Shade",
    "sowing_method": "Sprinke spores on surface of compost and peat moss, gently mix in, and press down.",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/mushroom.jpg",
    "icon": "/crops/icons/mushroom.avif"
}